import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MapLegendItems } from '../models/map-legend.items';

const COMPONENT_SELECTOR = 'ct-map-legend-item';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './map-legend-item.component.html',
  styleUrl: './map-legend-item.component.scss',
  standalone: false,
})
export class MapLegendItemComponent {
  @Input()
  set mapLegendItem(value: MapLegendItems) {
    this.processLegendItem(value);
    this._mapLegendItem = value;
  }

  get mapLegendItem(): MapLegendItems {
    return this._mapLegendItem;
  }

  private _mapLegendItem: MapLegendItems;
  isLayerLine: boolean;
  isLayerPolygon: boolean;

  constructor(private _sanitizer: DomSanitizer) {}

  private processLegendItem(value: MapLegendItems) {
    if (
      value &&
      (value.layerType === 'Line' ||
        value.layerType === 'MultiLine' ||
        value.layerType === 'LineString')
    ) {
      this.isLayerLine = true;
      this.isLayerPolygon = false;
    } else if (value && value.layerType === 'Polygon') {
      this.isLayerPolygon = true;
      this.isLayerLine = false;
    } else {
      this.isLayerLine = false;
      this.isLayerPolygon = false;
      if (value && Array.isArray(value.items)) {
        value.items.forEach((item) => {
          if (item.iconPath && typeof item.iconPath === 'string') {
            item.iconPath = this._sanitizer.bypassSecurityTrustHtml(
              item.iconPath.replace(/\"/g, '"')
            );
          }
        });
      }
    }
  }
}
